export default "__VITE_ASSET__CQSpP0ng__"